<template>
  <base-draggable-modal
      name="base_report"
      max-height="80vh"
      width="70vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="base_report">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate("progress_report") }} {{ moment().format("DD-MM-YYYY") }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-row>
              <v-col>
                <h1 class="text-h3 text-primary">{{ record.name }}</h1>
                <div class="sm-medium text-primary mt-3">{{ record.description }}</div>
                <div class="sm-medium text-primary">{{ record.tags.join(", ") }}</div>
                <span class="sm-medium text-primary">{{ $store.getters.translate('root_asset_name') }}: {{ record.root_asset_name }}
                  <template v-if="record.second_root_asset_id">, {{ record.second_root_asset_name }}</template>
                   <template v-if="record.third_root_asset_id">, {{ record.third_root_asset_name }}</template>
                   <template v-if="record.fourth_root_asset_id">, {{ record.fourth_root_asset_name }}</template>
                   <template v-if="record.fifth_root_asset_id">, {{ record.fifth_root_asset_name }}</template>
                </span>
                <span class="mx-1">•</span>
                <span class="sm-medium text-primary">{{ record.afe_pef }}</span>
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col>
                <div class="sm-medium text-subtle">{{ $store.getters.translate("filter_by_tags").toUpperCase() }}</div>
                <v-radio-group v-model="selected_stats_tag" class="mt-3" density="compact" hide-details inline>
                  <v-radio
                      density="compact"
                      color="success"
                      class="mr-2"
                      v-for="(key, index) in Object.keys(all_stats)"
                      :value="key"
                      :key="index"
                      hide-details
                      small>
                    <template #label>
                      <span class="sm-normal text-subtle">{{ $store.getters.translate(key) }}</span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col><span class="sm-medium text-subtle">{{ $store.getters.translate('progress') }}: {{ Math.floor((stats_rows.commissioned * 100) / stats_rows.amount) }}%</span></v-col>
              <v-col><span class="sm-medium text-subtle">{{ $store.getters.translate('nr_documents') }}: {{ stats_rows.amount }}</span></v-col>
              <v-col><span class="sm-medium text-subtle">{{ $store.getters.translate('nr_commissioned') }}: {{ stats_rows.commissioned }}</span></v-col>
            </v-row>
            <v-text-field
                density="default"
                class="reg-normal text-primary mt-3"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.remarks"
                hide-details
                flat
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('remarks') }}</span>
              </template>
            </v-text-field>
            <v-card class="pa-5 mt-5" rounded="xl" border="sm" variant="outlined">
              <template v-for="(item, type) in stats_rows">
                <template v-if="type !== 'amount' && type !== 'commissioned' && type !== 'status_not_set' && type !== 'assembled' && type !== 'disassembled' && type !== 'tightened' && type !== 'n_a'">
                  <template v-for="(value, subtype) in item">
                    <v-card-item class="pa-0">
                      <v-card-title class="reg-bold text-primary">
                        {{ type }} > {{ subtype }}
                      </v-card-title>
                      <v-card-text class="pa-0">
                        <v-row align="center">
                          <v-col>
                            <v-progress-linear height="15" rounded rounded-bar :model-value="calculatePercentage(value)"/>
                          </v-col>
                          <v-col cols="1" class="ml-5">
                            <span class="text-primary lg-medium">{{ Math.floor(calculatePercentage(value)) }}%</span>
                          </v-col>
                        </v-row>
                        <v-row class="mt-0">
                          <v-col>
                            <span class="reg-normal pa-0" style="opacity: 50%">{{ value.commissioned }} {{ $store.getters.translate('commissioned') }} - {{ value.amount }} {{ $store.getters.translate('total') }}</span>
                          </v-col>
                        </v-row>
                        <template v-if="type === 'Certificates' && subtype === 'Certificate'">
                          <!-- Tightened -->
                          <v-row>
                            <v-col class="reg-bold text-primary">
                              {{ $store.getters.translate('flange_tightened') }}
                            </v-col>
                          </v-row>
                          <v-row align="center">
                            <v-col>
                              <v-progress-linear height="15" color="#f1c40f" rounded rounded-bar :model-value="calculateFlangePercentage(stats_rows['tightened'], value.amount)"/>
                            </v-col>
                            <v-col cols="1" class="ml-5">
                              <span class="text-primary lg-medium">{{ Math.floor(calculateFlangePercentage(stats_rows['tightened'], value.amount)) }}%</span>
                            </v-col>
                          </v-row>
                          <v-row class="mt-0">
                            <v-col>
                              <span class="reg-normal pa-0" style="opacity: 50%">{{ stats_rows['tightened'] }} {{ $store.getters.translate('tightened') }} - {{ value.amount }} {{ $store.getters.translate('total') }}</span>
                            </v-col>
                          </v-row>
                          <!-- Assembled -->
                          <v-row>
                            <v-col class="reg-bold text-primary">
                              {{ $store.getters.translate('flange_assembled') }}
                            </v-col>
                          </v-row>
                          <v-row align="center">
                            <v-col>
                              <v-progress-linear height="15" color="#e03e2d" rounded rounded-bar :model-value="calculateFlangePercentage(stats_rows['assembled'], value.amount)"/>
                            </v-col>
                            <v-col cols="1" class="ml-5">
                              <span class="text-primary lg-medium">{{ Math.floor(calculateFlangePercentage(stats_rows['assembled'], value.amount)) }}%</span>
                            </v-col>
                          </v-row>
                          <v-row class="mt-0">
                            <v-col>
                              <span class="reg-normal pa-0" style="opacity: 50%">{{ stats_rows['assembled'] }} {{ $store.getters.translate('assembled') }} - {{ value.amount }} {{ $store.getters.translate('total') }}</span>
                            </v-col>
                          </v-row>
                          <!-- Disassembled -->
                          <v-row>
                            <v-col class="reg-bold text-primary">
                              {{ $store.getters.translate('flange_disassembled') }}
                            </v-col>
                          </v-row>
                          <v-row align="center">
                            <v-col>
                              <v-progress-linear height="15" color="#3598db" rounded rounded-bar :model-value="calculateFlangePercentage(stats_rows['disassembled'], value.amount)"/>
                            </v-col>
                            <v-col cols="1" class="ml-5">
                              <span class="text-primary lg-medium">{{ Math.floor(calculateFlangePercentage(stats_rows['disassembled'], value.amount)) }}%</span>
                            </v-col>
                          </v-row>
                          <v-row class="mt-0">
                            <v-col>
                              <span class="reg-normal pa-0" style="opacity: 50%">{{ stats_rows['disassembled'] }} {{ $store.getters.translate('disassembled') }} - {{ value.amount }} {{ $store.getters.translate('total') }}</span>
                            </v-col>
                          </v-row>
                          <!-- N/A -->
                          <v-row>
                            <v-col class="reg-bold text-primary">
                              N/A
                            </v-col>
                          </v-row>
                          <v-row align="center">
                            <v-col>
                              <v-progress-linear height="15" color="#cc7a00" rounded rounded-bar :model-value="calculateFlangePercentage(stats_rows['n_a'], value.amount)"/>
                            </v-col>
                            <v-col cols="1" class="ml-5">
                              <span class="text-primary lg-medium">{{ Math.floor(calculateFlangePercentage(stats_rows['n_a'], value.amount)) }}%</span>
                            </v-col>
                          </v-row>
                          <v-row class="mt-0">
                            <v-col>
                              <span class="reg-normal pa-0" style="opacity: 50%">{{ stats_rows['n_a'] }} N/A - {{ value.amount }} {{ $store.getters.translate('total') }}</span>
                            </v-col>
                          </v-row>
                          <!-- Not Set -->
                          <v-row>
                            <v-col class="reg-bold text-primary">
                              {{ $store.getters.translate('flange_status_not_set') }}
                            </v-col>
                          </v-row>
                          <v-row align="center">
                            <v-col>
                              <v-progress-linear height="15" color="#a11203" rounded rounded-bar :model-value="calculateFlangePercentage(stats_rows['status_not_set'], value.amount)"/>
                            </v-col>
                            <v-col cols="1" class="ml-5">
                              <span class="text-primary lg-medium">{{ Math.floor(calculateFlangePercentage(stats_rows['status_not_set'], value.amount)) }}%</span>
                            </v-col>
                          </v-row>
                          <v-row class="mt-0">
                            <v-col>
                              <span class="reg-normal pa-0" style="opacity: 50%">{{ stats_rows['status_not_set'] }} {{ $store.getters.translate('status_not_set') }} - {{ value.amount }} {{ $store.getters.translate('total') }}</span>
                            </v-col>
                          </v-row>
                        </template>
                      </v-card-text>
                    </v-card-item>
                    <v-divider class="mt-3 mb-3" />
                  </template>
                </template>
              </template>
            </v-card>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="closeModal('base_report')">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="downloadReport">
                  <template #prepend><PhDownloadSimple style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("download") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import {PhDownloadSimple, PhX} from "@phosphor-icons/vue";

export default {
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    PhDownloadSimple, PhX,
  },
  data() {
    return {
      page: helpFunctions.pages.reports,
      record: {},
      all_stats: [],
      stats_rows: [],
      selected_stats_tag: "with_tags",
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load(item, loaded_data = null) {
      this.record = item;
      this.openModal('base_report');
      if(loaded_data) {
        this.all_stats = loaded_data;
        this.stats_rows = this.all_stats["with_tags"];
      }
      else {
        this.all_stats = await helpFunctions.postCustomRoute(this.$toast, "project-report", { project_id: this.record.id }, false, true);
        this.stats_rows = this.all_stats["with_tags"];
      }
    },
    async downloadReport() {
      let report_tags = "";
      if(this.selected_stats_tag === "with_tags"/* || this.selected_stats_tag === "all"*/) {
        report_tags = this.record.tags.join(", ");
      }
      else {
        report_tags = this.selected_stats_tag;
      }
      let file_name = this.record.name.replaceAll('"', '').replaceAll("'", "").replaceAll('\\', ' ');
      file_name = file_name.replaceAll('/', ' ').replaceAll('(', ' ').replaceAll(')', ' ');
      file_name = file_name.replaceAll('   ', ' ').replaceAll('  ', ' ');
      file_name = "Progress report " + file_name + " " + report_tags + ".pdf";

      let response = await helpFunctions.getPDFFile(this.$toast, "pdf/generate-project-report", {
        project_id: this.record.id,
        selected_stats_tag: this.selected_stats_tag,
        report_tags: report_tags,
        file_name: file_name,
        template_id: 2
      });
      const blob = new Blob([response], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = file_name;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    calculatePercentage(item) {
      return (item.commissioned * 100) / item.amount;
    },
    calculateFlangePercentage(flange_amount, amount) {
      return (flange_amount * 100) / amount;
    },
  },
  watch: {
    selected_stats_tag: {
      handler() {
        this.stats_rows = this.all_stats[this.selected_stats_tag];
      },
    },
  }
};
</script>